<template>
  <v-container>
    <v-toolbar  width='1200px' class="toolbarHack213" flat fixed app>
      <a href="https://app.smartpress.co" target="blank"><img
        
        src="../../assets/logo.png"
        height="50px"
        style="margin:0 30px;"

      /></a>

      <b-nav-item-dropdown 
          v-if="isAuthenticated" 
          right>
          <template slot="button-content">
            <icon name="user-circle"/><strong class="nav-username">{{ user.username }}</strong>
          </template>
          <b-row 

            class="justify-content-md-center" 
            >
            <b-dropdown-item style='width:90% !important' to="/billing"><icon name="Billing"/><span>Billing</span></b-dropdown-item>
            <b-dropdown-item style='width:90%' to="/changePassword"><span  >Change Password</span></b-dropdown-item>
            <b-dropdown-item style='width:90%' to="/signOut"><icon name="sign-out"/><span  >Sign Out</span></b-dropdown-item>
          </b-row>
        </b-nav-item-dropdown>
    </v-toolbar>
    <v-layout>
      <v-flex style="margin-top:100px;"  class="text-xs-center justify-center">
        <img
          src="../../assets/payments/success.svg"
          height="180px"
          style="padding:15px; "
        >
        </img>
        <h4 style="margin-top:10px;">Payment Successful</h4>
        <v-btn small :to="'/myContracts'">Dashboard</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from "@/store"
export default {


  created: function () {
    console.log(this.$route)
    console.log(this.$route.query.session_id)

    this.$store.dispatch('payments/stripePaySuccess', {session_id: this.$route.query.session_id})
  }
    
}
</script>
